import { render, staticRenderFns } from "./RegisterSteps.vue?vue&type=template&id=6984e918&"
import script from "./RegisterSteps.vue?vue&type=script&lang=js&"
export * from "./RegisterSteps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports